import type { RegisteredSource } from "view/dashboard/widgets/sources/types";
import declarationCount from "view/dashboard/widgets/sources/DeclarationCount";
import invoiceCount from "view/dashboard/widgets/sources/InvoiceCount";
export type * from "view/dashboard/widgets/sources/types";

export const SOURCES = {
	DECLARATION_COUNT: declarationCount,
	INVOICE_COUNT: invoiceCount,
} satisfies Record<string, RegisteredSource>;

export type SourceId = keyof typeof SOURCES;
export type SourceRegistry = Record<SourceId, RegisteredSource>;
